import Rest from '../rest'
import { apiMicro } from '@/plugins/axios'
/******************************************************************************
 * Generate Reports
 *****************************************************************************/

/**
 * @type {GenerateReports}
 */
export default class GenerateReports extends Rest {

    constructor (options = {}) {
        super('/reports', options)
        this.http = apiMicro
    }
}

